<template>
  <Window
    title="Drone"
    window-name="drone"
    :icon-src="require('@/assets/task-bar-icons/icon-drone.svg')"
  >
    <div class="container">
      <div
        class="reset-overlay"
        :class="{ visible: decisionTime || decisionMade }"
      >
        <div>Account Locked</div>
        <button @click="onResetClick">Reset Game</button>
      </div>
      <DecisionDialog
        :visible="
          currentDelivery &&
            decisionTime &&
            !isEndOfDay &&
            !showFailureDialog &&
            !delivering &&
            windowShown
        "
        @accept="onDecisionMade"
      />
      <DroneOrderDialog
        :class="{ black: decisionTime || decisionMade }"
        :customer="currentDelivery.customer"
        :order="currentDelivery.order"
        :items="currentDelivery.items"
        :warehouse="currentDelivery.warehouse"
        :address="currentDelivery.address"
        :note="currentDelivery.note"
        :visible="
          currentDelivery &&
            !isEndOfDay &&
            !showFailureDialog &&
            !delivering &&
            windowShown
        "
        @accept="onOrderAccept"
        v-if="currentDelivery"
      />
      <EndOfDayDialog
        :class="{ black: decisionTime || decisionMade }"
        :times="times"
        :visible="isEndOfDay && !delivering && windowShown"
        :gameStateKey="gameStateKey"
        @accept="onEndOfDayAccept"
      />
      <FailureDialog
        :class="{ black: decisionTime || decisionMade }"
        :visible="showFailureDialog && !delivering && windowShown"
        @accept="onFailureAccept"
      />
      <DroneMap
        :class="{ black: decisionTime || decisionMade }"
        :initialDroneCoordinatesP="currentDelivery.initialDroneCoordinates"
        :destinationCoordinatesP="currentDelivery.destinationCoordinates"
        :warehouseCoordinatesP="currentDelivery.warehouseCoordinates"
        :noFlyZonesP="currentDelivery.noFlyZones"
        :mapP="currentDelivery.map"
        :gameStateKeyP="gameStateKey"
        :delivering="delivering"
        @finishDelivery="onFinishDelivery"
        v-if="currentDelivery"
      />
    </div>
  </Window>
</template>

<script>
import DecisionDialog from "./DecisionDialog";
import DroneOrderDialog from "./DroneOrderDialog";
import EndOfDayDialog from "./EndOfDayDialog";
import FailureDialog from "./FailureDialog";
import DroneMap from "./DroneMap";
import Window from "@/components/shared/Window";
import gameStateKeys from "@/assets/gameStateKeys";
import gameStateStore, {
  incrementState,
  resetState,
} from "@/stores/GameStateStore";
import windowStateStore, {
  minimizeWindow,
  showWindow,
  bringWindowToFront,
} from "@/stores/WindowStateStore";

export default {
  name: "DroneWindow",
  components: {
    Window,
    DroneOrderDialog,
    EndOfDayDialog,
    FailureDialog,
    DecisionDialog,
    DroneMap,
  },
  data() {
    return {
      deliveryData: undefined,
      deliveriesCount: 0,
      delivering: false,
      times: [],
      isEndOfDay: false,
      showFailureDialog: false,
      decisionTime: false,
      decisionMade: gameStateStore.stateKey.includes("day4"),
    };
  },
  computed: {
    currentDelivery() {
      if (this.deliveryData && this.deliveryData[gameStateStore.stateKey])
        return this.deliveryData[gameStateStore.stateKey][this.deliveriesCount];

      return undefined;
    },
    windowShown() {
      return windowStateStore.visibleWindows.includes("drone");
    },
    gameStateKey() {
      return gameStateStore.stateKey;
    },
  },
  methods: {
    onOrderAccept(accept) {
      if (accept) this.delivering = true;
      else {
        if (
          this.deliveriesCount + 1 >=
          this.deliveryData[gameStateStore.stateKey].length
        )
          this.isEndOfDay = true;
        else this.incrementDelivery();
      }
    },
    onEndOfDayAccept() {
      this.isEndOfDay = false;

      if (this.gameStateKey !== "day3") {
        setTimeout(() => {
          minimizeWindow("drone");

          setTimeout(() => {
            showWindow("email");
            bringWindowToFront("email");

            this.incrementDelivery();
          }, 100);
        }, 100);
      } else {
        setTimeout(() => {
          minimizeWindow("drone");

          setTimeout(() => {
            showWindow("email");
            bringWindowToFront("email");

            this.decisionTime = true;
          }, 100);
        }, 100);
      }
    },
    onDecisionMade(side) {
      this.decisionTime = false;
      this.decisionMade = true;

      this.deliveriesCount = 0;
      this.times = [];

      if (side === "A") gameStateStore.stateKey = "day4a";
      else if (side === "A") gameStateStore.stateKey = "day4b";

      setTimeout(() => {
        minimizeWindow("drone");

        setTimeout(() => {
          showWindow("email");
          bringWindowToFront("email");

          showWindow("social");
          bringWindowToFront("social");
        }, 100);
      }, 100);
    },
    onFailureAccept() {
      this.showFailureDialog = false;
      if (
        this.deliveriesCount + 1 >=
        this.deliveryData[gameStateStore.stateKey].length
      )
        this.isEndOfDay = true;
      else this.incrementDelivery();
    },
    onFinishDelivery(success, time) {
      if (success) {
        this.times.push(time);
        this.delivering = false;
        if (
          this.deliveriesCount + 1 >=
          this.deliveryData[gameStateStore.stateKey].length
        )
          this.isEndOfDay = true;
        else this.incrementDelivery();
      } else {
        this.delivering = false;
        this.showFailureDialog = true;
      }
    },
    onResetClick() {
      resetState();

      window.location.reload();
    },
    incrementDelivery() {
      this.deliveriesCount++;

      if (
        this.deliveriesCount >=
        this.deliveryData[gameStateStore.stateKey].length
      ) {
        this.deliveriesCount = 0;
        this.times = [];
        incrementState();
      }
    },
  },
  async mounted() {
    const deliveryJsons = await Promise.all(
      (
        await Promise.all(
          gameStateKeys.map(key =>
            Promise.all([
              fetch(`/game-content/${key}/drone/main.json`),
              Promise.resolve(key),
            ])
          )
        )
      )
        .filter(([response]) => response.ok)
        .map(([response, key]) =>
          Promise.all([response.json(), Promise.resolve(key)])
        )
    );

    this.deliveryData = {};

    deliveryJsons.map(([value, key]) => {
      this.deliveryData[key] = value;
    });
  },
};
</script>

<style scoped lang="scss">
.container {
  position: relative;

  width: 100%;
  height: 100%;

  user-select: none;

  .reset-overlay {
    display: none;

    &.visible {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      background-color: black;
    }
  }

  .black {
    display: none;

    & * {
      display: none;
    }
  }
}
</style>
